import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=dae2e1dc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=dae2e1dc&prod&lang=less&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=dae2e1dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae2e1dc",
  null
  
)

export default component.exports